import {FlexBox} from '@brg/ui';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowSmallIcon from 'shared/icons/ArrowSmallIcon';
import styled, { css, useTheme } from 'styled-components';

export const TagBtnWrapper = styled(FlexBox)<{ rotateSvg?: boolean, isCompetition?: boolean }>`
    cursor: pointer;
    column-gap: 8px;
    align-items: center;
    padding: 6px 16px;
    border: 1px solid ${({ theme, rotateSvg }) => rotateSvg 
            ? theme.projectEdit.btns.tag.borderActive  : theme.projectEdit.btns.tag.border};
    background: ${({ theme, rotateSvg }) => rotateSvg ? theme.projectEdit.btns.tag.bgActive : 'none'};
    transition: 0.2s background;
    border-radius: 3px;

    ${({ isCompetition, rotateSvg, theme }) => isCompetition && css`
        border: 1px solid ${theme.projectEdit.btns.tag.border};
        background: none;
    `}
    ${({ rotateSvg }) => rotateSvg ? css`
    svg {
        transform: rotate(0deg);
        transition: 0.2s transform;
    }
    ` : css`
    svg {
        transform: rotate(180deg);
        transition: 0.2s transform;
    }
    `};

  svg {
    path {
      fill: ${({ theme, rotateSvg }) => rotateSvg
              ? theme.projectEdit.btns.tag.colorActive
              : theme.projectEdit.btns.tag.border};

        ${({ isCompetition, rotateSvg, theme }) => isCompetition && css`
            fill: ${theme.projectEdit.btns.tag.border}
        `}
    }
  }
`

export const TabBtnText = styled.div<{ rotateSvg?: boolean, isCompetition?: boolean }>`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: ${({ theme, rotateSvg }) => rotateSvg
          ? theme.projectEdit.btns.tag.colorActive
          : theme.projectEdit.btns.tag.color};

    ${({ isCompetition, rotateSvg, theme }) => isCompetition && css`
        color: ${theme.projectEdit.btns.tag.color}
    `}
`;

export const TagsMobBtn: FC<{ onClick: (s: boolean) => void, flag: boolean, isCompetition?: boolean, customText?: string, hide?: boolean }> = ({ onClick, flag, isCompetition, customText, hide }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    if (hide) {
        return null
    }
    return(
        <TagBtnWrapper isCompetition={isCompetition} directionMobile='row' alignMobile='center' onClick={() => onClick(!flag)} rotateSvg={flag}>
            <TabBtnText isCompetition={isCompetition} rotateSvg={flag}>{customText || t('tags_mobile_btn_text')}</TabBtnText>
            <ArrowSmallIcon fill={theme.projectEdit.btns.tag.border} />
        </TagBtnWrapper>
    )
}import {FlexBox} from '@brg/ui';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowSmallIcon from 'shared/icons/ArrowSmallIcon';
import styled, { css, useTheme } from 'styled-components';

export const TagBtnWrapper = styled(FlexBox)<{ rotateSvg?: boolean, isCompetition?: boolean }>`
    cursor: pointer;
    column-gap: 8px;
    align-items: center;
    padding: 6px 16px;
    border: 1px solid ${({ theme, rotateSvg }) => rotateSvg 
            ? theme.projectEdit.btns.tag.borderActive  : theme.projectEdit.btns.tag.border};
    background: ${({ theme, rotateSvg }) => rotateSvg ? theme.projectEdit.btns.tag.bgActive : 'none'};
    transition: 0.2s background;
    border-radius: 3px;

    ${({ isCompetition, rotateSvg, theme }) => isCompetition && css`
        border: 1px solid ${theme.projectEdit.btns.tag.border};
        background: none;
    `}
    ${({ rotateSvg }) => rotateSvg ? css`
    svg {
        transform: rotate(0deg);
        transition: 0.2s transform;
    }
    ` : css`
    svg {
        transform: rotate(180deg);
        transition: 0.2s transform;
    }
    `};

  svg {
    path {
      fill: ${({ theme, rotateSvg }) => rotateSvg
              ? theme.projectEdit.btns.tag.colorActive
              : theme.projectEdit.btns.tag.border};

        ${({ isCompetition, rotateSvg, theme }) => isCompetition && css`
            fill: ${theme.projectEdit.btns.tag.border}
        `}
    }
  }
`

export const TabBtnText = styled.div<{ rotateSvg?: boolean, isCompetition?: boolean }>`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: ${({ theme, rotateSvg }) => rotateSvg
          ? theme.projectEdit.btns.tag.colorActive
          : theme.projectEdit.btns.tag.color};

    ${({ isCompetition, rotateSvg, theme }) => isCompetition && css`
        color: ${theme.projectEdit.btns.tag.color}
    `}
`;

export const TagsMobBtn: FC<{ onClick: (s: boolean) => void, flag: boolean, isCompetition?: boolean, customText?: string, hide?: boolean }> = ({ onClick, flag, isCompetition, customText, hide }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    if (hide) {
        return null
    }
    return(
        <TagBtnWrapper isCompetition={isCompetition} directionMobile='row' alignMobile='center' onClick={() => onClick(!flag)} rotateSvg={flag}>
            <TabBtnText isCompetition={isCompetition} rotateSvg={flag}>{customText || t('tags_mobile_btn_text')}</TabBtnText>
            <ArrowSmallIcon fill={theme.projectEdit.btns.tag.border} />
        </TagBtnWrapper>
    )
}